import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/JourneysPageQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';

export const journeysEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() => {
		if (!__SERVER__) {
			return import(
				/* webpackChunkName: "async-servicedesk-journeys", jiraSpaEntry: "async-servicedesk-journeys" */ './src/ui/JourneysPage'
			);
		}
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return Promise.resolve({ default: () => null }) as unknown as Promise<{
			default: typeof import('./src/ui/JourneysPage').default;
		}>;
	}),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			journeysPageQueryRef: {
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey || '',
					isFGEnabled: fg('journey_builder_support_versioning'),
				},
				options: {
					fetchPolicy: 'store-and-network' as const,
				},
			},
		},
		entryPoints: {},
		extraProps: {},
	}),
});
